import { ClockIcon, GraphDownIcon, LockIcon, MoneyCircleIcon, PiggyBankIcon, SmartphoneIcon } from '@cash-me/react-components'
export const benefits = [
  {
    id: '1',
    icon: GraphDownIcon,
    title: 'Taxas mais baixas',
    description: 'Opções pré e pós-fixadas.'
  },
  {
    id: '2',
    icon: PiggyBankIcon,
    title: 'Valores maiores',
    description: 'A partir de R$ 50 mil em empréstimo.'
  },
  {
    id: '3',
    icon: ClockIcon,
    title: 'Prazos mais longos',
    description: 'Até 240 meses para pagar.'
  },
  {
    id: '4',
    icon: MoneyCircleIcon,
    title: 'Pagamento flexível',
    description: 'Você começa a pagar em até 3 meses após a liberação.'
  },
  {
    id: '5',
    icon: LockIcon,
    title: 'Seguro e confiável',
    description: 'Você tem uma experiência que garante sua proteção.'
  },
  {
    id: '6',
    icon: SmartphoneIcon,
    title: 'Comodidade',
    description: 'Você nem precisa sair de casa. Tudo acontece totalmente online.'
  }
]
